import {Injectable} from '@angular/core';
import {AngularFireAuth} from 'angularfire2/auth';
import {Http, Headers, RequestOptions} from '@angular/http';

import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {apiUrl} from '../../config/api.config';

@Injectable()
export class RestApiRegisterService {
  baseUrl = (apiUrl);

  constructor(private http: Http,
              private afAuth: AngularFireAuth) {
  }


  /**
   * Register Landlord
   * @param email
   * @param password
   * @param schoolname
   * @param contact
   * @returns {Observable<Observable<any>>}
   */
  registerLandlord(email, password, street, city, state, apt, zip) {
    return this.apiRegisterLandlordWithEmailPassword(email, password, street, city, state, apt, zip);
  }

  /**
   * Register Landlord and Get Custom token from Rest API
   * @param email
   * @param password
   * @param schoolname
   * @param contact
   * @returns {Observable<any>}
   */
  private apiRegisterLandlordWithEmailPassword(email, password, street, city, state, apt, zip): Observable<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let appendix = apt;
    if (apt == null) {
      appendix = '';
    }

    const options = new RequestOptions({headers: headers});
    const body = ({
      email: email,
      password: password,
      street: street,
      city: city,
      state: state,
      apt: appendix,
      zip: zip,
    });

    console.log('Body: ', body);
    return this.http
      .post(this.baseUrl + 'registerLandlord', body, options)
      .map(response => response.json());
  }


  /**
   * Register Tenant and Send Invite from Rest API
   * @param email
   * @param password
   * @param schoolname
   * @param contact
   * @returns {Observable<any>}
   */
  apiRegisterAndInviteTenant(street, city, state, org_id, property_id, message, email): Observable<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let personalmessage = message;
    if (message == null) {
      personalmessage = '';
    }

    const options = new RequestOptions({headers: headers});
    const body = ({
      org_id: org_id,
      property_id: property_id,
      street: street,
      city: city,
      state: state,
      message: personalmessage,
      email: email
    });

    console.log('Body: ', body);
    return this.http
      .post(this.baseUrl + 'registerTenant', body, options)
      .map(response => response.json());
  }


  /**
   * Convert Promise of Firebase to an Observable
   * @param promise
   * @returns {Observable<any>}
   */
  private fromFirebaseAuthPromise(promise): Observable<any> {

    const subject = new Subject<any>();

    promise
      .then(res => {
          subject.next(res);
          subject.complete();
        },
        err => {
          subject.error(err);
          subject.complete();
        }
      );
    return subject.asObservable();
  }


}








// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/rest-api/register.service.ts